import { Button } from "@/components/ui/Button";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/Popover";
import Spinner from "@/components/ui/Spinner";
import useFetch from "@/hooks/useFetch";
import Image from "next/image";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { BsCardImage } from "react-icons/bs";
import useStore from "store";

export default function CardImage({ serial }) {
  const { t } = useTranslation("dashboard");
  const [isOpen, setIsOpen] = useState(false);
  const { isLoading, value } = useFetch(async () => {
  if (!isOpen) return null;
  const res = await getCardImage(serial);
  return res;
  }, [isOpen, serial]);
  const getCardImage = useStore(state => state.getCardImage);

  return (
    <Popover open={isOpen} onOpenChange={setIsOpen}>
      <PopoverTrigger asChild>
        <Button size="icon" variant="ghost" className="h-8 w-8">
          <BsCardImage />
        </Button>
      </PopoverTrigger>
      <PopoverContent align="end">
        <span> {t("popovers.card_image.title")} </span>
        {isLoading ? (
          <Spinner />
        ) : (
          <Image
            src={"data:image/jpeg;base64," + value}
            alt={t("popovers.card_image.image_unavailable")}
            width={220}
            height={100}
          />
        )}
      </PopoverContent>
    </Popover>
  );
}
